import { render, staticRenderFns } from "./translation.vue?vue&type=template&id=a0688f60&scoped=true"
import script from "./translation.vue?vue&type=script&lang=js"
export * from "./translation.vue?vue&type=script&lang=js"
import style0 from "./translation.vue?vue&type=style&index=0&id=a0688f60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0688f60",
  null
  
)

export default component.exports